import PageShell from '../../components/feature/PageShell';
import PageHero from '../../components/feature/PageHero';
import ServicesSection from '../home/components/ServicesSection';
import TreatmentCardsSection from '../home/components/TreatmentCardsSection';
import BenefitsSection from '../home/components/BenefitsSection';

export default function ServiciosPage() {
  return (
    <PageShell>
      {(onOpenModal) => (
        <>
          <PageHero
            title="Nuestros"
            highlight="Servicios"
            subtitle="Lo que ofrecemos"
            bgImage="https://readdy.ai/api/search-image?query=modern%20dental%20clinic%20equipment%20professional%20dental%20chair%20instruments%20tools%20clean%20white%20room%20blue%20lighting%20high%20tech%20dentistry%20facility%20bright%20professional&width=1920&height=600&seq=servicios-hero-001&orientation=landscape"
            breadcrumbs={[
              { label: 'Inicio', to: '/' },
              { label: 'Servicios' },
            ]}
          />
          <ServicesSection />
          <TreatmentCardsSection />
          <BenefitsSection />
          <ServicesCTASection onOpenModal={onOpenModal} />
        </>
      )}
    </PageShell>
  );
}

interface CTAProps {
  onOpenModal: () => void;
}

function ServicesCTASection({ onOpenModal }: CTAProps) {
  return (
    <section className="py-24 bg-[#0A2540] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-80 h-80 bg-[#3A86FF]/10 rounded-full blur-[100px]" />
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-4">
          ¿Listo para comenzar?
        </span>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6">
          Agenda tu{' '}
          <span className="bg-gradient-to-r from-[#3A86FF] to-[#6aa3ff] bg-clip-text text-transparent">
            primera consulta
          </span>
        </h2>
        <p className="text-white/65 text-lg mb-10 font-light max-w-2xl mx-auto leading-relaxed">
          Nuestros especialistas evaluarán tu caso y te recomendarán el tratamiento ideal. Primera valoración sin costo.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={onOpenModal}
            className="flex items-center gap-2 bg-[#3A86FF] hover:bg-[#1a6aff] text-white px-8 py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-line" />
            </div>
            Agendar Consulta
          </button>
          <a
            href="https://wa.me/525534748982"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 border border-white/25 hover:border-[#25D366] text-white hover:text-[#25D366] px-8 py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line" />
            </div>
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
